var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_2358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16699 40.0001C4.16699 20.2099 20.2101 4.16675 40.0003 4.16675C59.7905 4.16675 75.8337 20.2099 75.8337 40.0001C75.8337 59.7903 59.7905 75.8334 40.0003 75.8334C20.2101 75.8334 4.16699 59.7903 4.16699 40.0001Z",
    fill: "#29ACD6",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 3.66675C19.934 3.66675 3.66699 19.9337 3.66699 40.0001C3.66699 60.0664 19.934 76.3334 40.0003 76.3334C60.0667 76.3334 76.3337 60.0664 76.3337 40.0001C76.3337 19.9337 60.0667 3.66675 40.0003 3.66675Z",
    stroke: "url(#paint0_linear_1_2358)",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_2358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1511 25.3665C41.7153 26.1354 43.6124 27.303 45.9358 28.7329L46.1558 28.8683C48.4816 30.2996 50.3781 31.4667 51.7829 32.5247C53.2091 33.5988 54.4456 34.7851 55.1093 36.3743C56.0747 38.6854 56.0747 41.3146 55.1093 43.6258C54.4456 45.215 53.2091 46.4012 51.7829 47.4754C50.3781 48.5333 48.4816 49.7005 46.1559 51.1317L45.9358 51.2672C43.6124 52.6971 41.7153 53.8647 40.1511 54.6336C38.5793 55.4063 36.9427 55.9891 35.2202 55.7961C32.7305 55.5172 30.5201 54.1308 29.1069 52.0574C28.1478 50.6503 27.8121 48.9423 27.6558 47.1261C27.4999 45.3153 27.5 42.9944 27.5 40.1198V39.8803C27.5 37.0056 27.4999 34.6848 27.6558 32.874C27.8121 31.0577 28.1478 29.3498 29.1069 27.9426C30.5201 25.8692 32.7305 24.4829 35.2202 24.204C36.9427 24.011 38.5794 24.5938 40.1511 25.3665ZM35.7769 29.1729C36.0385 29.1436 36.603 29.1937 37.9453 29.8536C39.2703 30.5049 40.9647 31.5445 43.4265 33.0596C45.8873 34.574 47.5806 35.6193 48.7749 36.5187C49.9696 37.4184 50.3479 37.9477 50.4956 38.3013C50.9459 39.3794 50.9459 40.6206 50.4956 41.6987C50.3479 42.0524 49.9696 42.5816 48.7749 43.4813C47.5806 44.3808 45.8873 45.426 43.4265 46.9404C40.9647 48.4555 39.2703 49.4951 37.9453 50.1465C36.603 50.8064 36.0385 50.8565 35.7769 50.8272C34.8051 50.7183 33.871 50.1694 33.2385 49.2414C33.0249 48.928 32.7742 48.2875 32.6374 46.6973C32.5022 45.1268 32.5 43.0226 32.5 40C32.5 36.9775 32.5022 34.8732 32.6374 33.3027C32.7742 31.7125 33.0249 31.0721 33.2385 30.7587C33.871 29.8306 34.8051 29.2818 35.7769 29.1729Z",
    fill: "url(#paint1_linear_1_2358)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_2358",
    x: -20.833,
    y: -20.8333,
    width: 121.667,
    height: 121.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_2358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_2358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_2358",
    x: 24.5,
    y: 21.1667,
    width: 44.333,
    height: 47.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2358",
    x1: 4.16699,
    y1: 4.16675,
    x2: 75.87,
    y2: 75.7971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2358",
    x1: 41.9053,
    y1: 62.5797,
    x2: 85.2455,
    y2: 24.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.784815b4157b27511d4de21d60522638.svg";
export { ForwardRef as ReactComponent };